<template>
  <div ref="stepsScreen" class="steps-screen">
    <nav class="steps-screen__nav">
      <slot name="stepper" />
    </nav>
    <div class="steps-screen__container" ref="steps">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'steps-screen'
}
</script>

<style lang="scss" scoped>
.steps-screen {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: 0;

  &__nav {
    position: fixed;
    top: 4.5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    background-color: #FFFFFF;
    z-index: 4;
  }

  &__container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media screen and (min-width: 641px) {
  .steps-screen {
    &__container {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
}
@media screen and (min-width: 769px) {
  .steps-screen {
    &__container {
      padding-left: 3rem;
    }
  }
}
@media screen and (min-width: 1281px) {
  .steps-screen {
    flex-direction: row;

    &__nav {
      flex-direction: column;
      top: 18rem;
      margin-left: 20px;
      max-width: 240px;
      background-color: transparent;
    }
    &__container {
      margin-left: 250px;
    }
  }
}
</style>
